import { type AtlasGqlTableView } from 'types/atlas-graphql';

export type DefectPatternAssetFilter = {
  key: string;
  value: string[];
};

export type MakeModel = {
  make?: string | null;
  model?: string | null;
};

export const getFilterValues = (view: AtlasGqlTableView, key: string): string[] =>
  view.filters?.asset?.find((filter: DefectPatternAssetFilter) => filter.key === key)?.value ?? [];

const hasMatchingModel = (viewModels: string[], configured: MakeModel[]): boolean =>
  viewModels.some((viewModel) => configured.some(({ model }) => model === viewModel));

export const getRelevantDefectPatterns = (
  views: AtlasGqlTableView[],
  turbineMakeModels: MakeModel[],
  bladeMakeModels: MakeModel[]
): AtlasGqlTableView[] =>
  views.filter((view) => {
    const turbineModels = getFilterValues(view, 'assetModel');
    const bladeModels = getFilterValues(view, 'componentModel');

    // Defect Patterns are make-agnostic and list every model they apply to, so matching a single one is enough.
    return (
      hasMatchingModel(turbineModels, turbineMakeModels) ||
      hasMatchingModel(bladeModels, bladeMakeModels)
    );
  });
